import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { PaystubDocumentPaystub } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/paystub";

export const EmployerInformationSlice = ({
  paystub
}: {
  paystub: PaystubDocumentPaystub;
}) => {
  return (
    <ContentTitle title="Employer information" contentClassName="space-y-2">
      <KeyValue
        label="Name"
        value={paystub.employer?.name || "-"}
        flagEmpty
        flagTooltip="Important income data is missing"
      />
      <KeyValue
        label="Address line 1"
        value={paystub.employer?.address?.line1 || "-"}
      />
      <KeyValue
        label="Address line 2"
        value={paystub.employer?.address?.line2 || "-"}
      />
      <KeyValue label="City" value={paystub.employer?.address?.city || "-"} />
      <KeyValue
        label="State"
        value={paystub.employer?.address?.state_code || "-"}
      />
      <KeyValue
        label="Zip"
        value={paystub.employer?.address?.postal_code || "-"}
      />
    </ContentTitle>
  );
};
